export enum DialogType {
  Alternative,
  Confirmation,
  PaymentDetails,
  RequestTrip,
  ScheduleCall,
  TopLevelTrip,
}
